<template>
  <Navbar />
  <div class="main-content">
    <router-view />
  </div>
  <Footer />
</template>

<script setup>
import Navbar from './components/layout/Navbar.vue'
import Footer from './components/layout/Footer.vue'
</script>

<style>
.main-content {
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--color-bg);
  /* 首页等无沉浸头图的页面：避开固定导航 */
  padding-top: 60px;
}

/* 产品/方案沉浸式头图：顶到视口，由头图自身处理避让 */
.main-content:has(.ai-hero-banner) {
  padding-top: 0;
}

@media (max-width: 1023px) {
  .main-content {
    padding-top: calc(56px + env(safe-area-inset-top));
  }

  .main-content:has(.ai-hero-banner) {
    padding-top: 0;
  }
}
</style>
